import React, { useEffect, useRef, useState } from 'react'
import { Button, Empty, Icon, Modal, Select } from 'antd'
import { WithTranslation, withTranslation } from 'react-i18next'
import { TimesheetProjectMode, TimesheetsStore } from '../stores/timesheets-store'
import './timesheet.less'

interface TimeSheetButtonProps {
  onLoad: () => void
  companyId: string
  employeeId: string
  showBtnCreateTimeSheet: boolean
}

const timesheetsStore = new TimesheetsStore()

const CreateSpecificTimeSheet: React.FC<TimeSheetButtonProps & WithTranslation> = ({ onLoad, companyId, employeeId, showBtnCreateTimeSheet, t }) => {
  const [modalVisible, setModalVisible] = useState(false)
  const [selectedProjects, setSelectedProjects] = useState<string[]>([])
  const [companyValue, setCompanyValue] = useState<boolean>(false)
  const [projectData, setProjectData] = useState<any[]>([])
  const [currentCompany, setCurrentCompany] = useState(companyId)

  const inputRef = useRef()

  useEffect(
    () => {
      fetchData()
    }, [inputRef]
  )
  useEffect(() => {
    if (companyId && companyId != currentCompany) {
      fetchData()
      setCurrentCompany(companyId)
    }
  }, [companyId])

  const fetchData = async () => {
    try {
      timesheetsStore.setBaseUrl(companyId)
      const companyData = await timesheetsStore.getCompanyTimesheetManual()
      if (typeof companyData === 'boolean') {
        setCompanyValue(companyData)
      }
    } catch (error) {
      console.error("Error al obtener los datos de la compañía:", error)
    }
  }

  const handleModalOpen = async () => {
    try {
      timesheetsStore.setBaseUrl(companyId)
      setModalVisible(true)
      const data = await timesheetsStore.getProjectEmployeeAsync(employeeId)
      setProjectData(data)
    } catch (error) {
      console.error("Error al obtener los proyectos:", error)
    }
  }

  const handleModalClose = () => {
    setModalVisible(false)
    setSelectedProjects([])
  }

  const handleProjectSelect = (selectedOption: any) => {
    setSelectedProjects(selectedOption)
  }

  const handleGenerateTimeSheet = async () => {
    const selectedProjectObjects: TimesheetProjectMode[] = selectedProjects.map(jsonString => JSON.parse(jsonString))
    setModalVisible(false)
    setSelectedProjects([])

    await timesheetsStore.generateTimesheetsWeek(employeeId, 'createSpecificTimeSheet', selectedProjectObjects)
    await onLoad()
  }

  return (
    <>
      {(companyValue && showBtnCreateTimeSheet) ? (
        <div className="div-clone">
          <Empty style={{ marginTop: 50 }} description={t("There is no timesheet for you available yet.")} />
          <Button className="btn-clone" onClick={() => handleModalOpen()} >
            {t('Generate Time Sheet')}  <Icon type="plus-circle" style={{ fontSize: '12px', color: 'white' }} />
          </Button>

          <Modal
            title={t('Select Projects')}
            visible={modalVisible}
            onCancel={handleModalClose}
            onOk={handleGenerateTimeSheet}
          >
            <Select
              mode="multiple"
              style={{ width: '100%' }}
              onChange={handleProjectSelect}
              placeholder={t('Select a project')}
            >
              {projectData.map(pro => (
                <Select.Option key={pro.projectId} value={JSON.stringify(pro)}
                  style={{ maxWidth: 450, wordWrap: 'break-word', whiteSpace: 'normal' }}>
                  {pro.projectTitle}
                </Select.Option>
              ))}
            </Select>
          </Modal>
        </div>
      ) : <Empty style={{ marginTop: 50 }} description={t("There is no timesheet for you available yet. Please contact your manager.")} />
      }
    </>
  )
}

export default withTranslation()(CreateSpecificTimeSheet) as any
